import { SectionDiv } from "./SectionDiv";

export function SectionErrorFallback({ title, className }: { title: string; className?: string }) {
    return (
        <SectionDiv className={className}>
            <h3 className="mb-3">{title}:</h3>
            <p>(Error loading {title})</p>
        </SectionDiv>
    );
}
